import type { MaybeAccount } from "@/auth/auth.service";
import { Auth } from "@/auth/auth.service";
import type { NavigationClient } from "@azure/msal-browser";
import { reactive, ref } from "vue";

type AuthStore = {
  error: string | undefined;
  account: MaybeAccount;
  initialized: boolean;
  initialize: (client?: NavigationClient) => Promise<MaybeAccount>;
  login: () => Promise<void>;
  logout: () => Promise<void>;
};

const initialized = ref(false);
const account = ref<MaybeAccount>(null);
const error = ref<string>();

async function initialize(client?: NavigationClient): Promise<MaybeAccount> {
  if (initialized.value === true) {
    return account.value;
  }
  return Auth.initialize(client).then((data) => {
    account.value = data;
    initialized.value = true;
    return data;
  });
}

async function login(): Promise<void> {
  error.value = "";
  return Auth.login()
    .then((data) => {
      account.value = data;
      error.value = "";
    })
    .catch(
      (err: { errorCode: string | undefined; message: string | undefined }) => {
        error.value = `${err.errorCode}: ${err.message}`;
        throw err;
      },
    );
}

async function logout(): Promise<void> {
  account.value = null;
  return Auth.logout();
}

export const getRoles = function (): string[] {
  return account.value?.idTokenClaims?.roles || [];
};

export const auth: AuthStore = reactive({
  error,
  account,
  initialized,
  initialize,
  login,
  logout,
});
